import {
  VGraphNavigator,
  VGraphNavigatorMobile,
} from '../../components/navigator';
import { copyWritings } from './copywritings';
import { ExampleView } from '../../../../components/example-view';
import type { exampleLoader } from '../../../../loader';
import { useLoaderData } from 'react-router-dom';

export function Example() {
  const loaderData = useLoaderData() as Awaited<
    ReturnType<typeof exampleLoader>
  >;
  const data = loaderData;

  return (
    <ExampleView
      data={data}
      siteType="vgraph"
      navigator={<VGraphNavigator selected="example" />}
      navigatorMobile={<VGraphNavigatorMobile selected="example" />}
      copyWritings={copyWritings}
    />
  );
}
